module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.$store.state.app.dialogVisible,
      "size": "tiny",
      "before-close": _vm.hasClck
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.$store.state.app, "dialogVisible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "login-star"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.app.sin_login),
      expression: "$store.state.app.sin_login"
    }],
    staticClass: "sign-box back_potion"
  }, [_c('div', {
    staticClass: "sign-top pt10"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/denlu.png?v=1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inpu-box"
  }, [_c('div', {
    staticClass: "input-form input-select"
  }, [_c('div', {
    staticClass: "select-num"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "menu-align": "start"
    },
    on: {
      "command": _vm.selse
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                    + " + _vm._s(_vm.nation_code) + "\n                    "), _c('img', {
    attrs: {
      "src": "/static/images/jinjiantou.png"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.nation), function(item, index) {
    return _c('el-dropdown-item', {
      attrs: {
        "command": item.nation_code
      }
    }, [_vm._v(_vm._s(item.nation_code))])
  }), 1)], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "placeholder": "请输入手机号码",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "placeholder": "请确认密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loGin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "send-btn margi-top23",
    on: {
      "click": _vm.loGin
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "send-btn new-closebtn",
    on: {
      "click": function($event) {
        return _vm.show(3)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "sign-bottom"
  }, [_c('div', {
    staticClass: "sign-bottom-left",
    on: {
      "click": function($event) {
        return _vm.show(1)
      }
    }
  }, [_c('span', [_vm._v("新用户注册")])]), _vm._v(" "), _c('div', {
    staticClass: "sign-bottom-right",
    on: {
      "click": function($event) {
        return _vm.show(2)
      }
    }
  }, [_c('span', [_vm._v("忘记密码")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.app.register),
      expression: "$store.state.app.register"
    }],
    staticClass: "sign-box back_potion"
  }, [_c('div', {
    staticClass: "sign-top pt10"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/denlu.png?v=1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inpu-box"
  }, [_c('div', {
    staticClass: "input-form input-select"
  }, [_c('div', {
    staticClass: "select-num"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "menu-align": "start"
    },
    on: {
      "command": _vm.selse
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                    + " + _vm._s(_vm.nation_code) + "\n                    "), _c('img', {
    attrs: {
      "src": "/static/images/jinjiantou.png"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.nation), function(item, index) {
    return _c('el-dropdown-item', {
      attrs: {
        "command": item.nation_code
      }
    }, [_vm._v(_vm._s(item.nation_code))])
  }), 1)], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "placeholder": "请输入手机号码",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "placeholder": "请输入短信验证码",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-text",
    class: {
      'gray': _vm.isGetCode || !_vm.form.phone
    },
    domProps: {
      "innerHTML": _vm._s(_vm.timerMsg)
    },
    on: {
      "click": function($event) {
        return _vm.getCode(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.new_password),
      expression: "form.new_password"
    }],
    attrs: {
      "placeholder": "请再次输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "new_password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "send-btn margin_26",
    on: {
      "click": function($event) {
        return _vm.register(1)
      }
    }
  }, [_vm._v("立即注册")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.app.forget),
      expression: "$store.state.app.forget"
    }],
    staticClass: "sign-box back_potion"
  }, [_c('div', {
    staticClass: "sign-top pt20"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/denlu.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inpu-box"
  }, [_c('div', {
    staticClass: "input-form input-select"
  }, [_c('div', {
    staticClass: "select-num"
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "menu-align": "start"
    },
    on: {
      "command": _vm.selse
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n                    + " + _vm._s(_vm.nation_code) + "\n                    "), _c('img', {
    attrs: {
      "src": "/static/images/jinjiantou.png"
    }
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.nation), function(item, index) {
    return _c('el-dropdown-item', {
      attrs: {
        "command": item.nation_code
      }
    }, [_vm._v(_vm._s(item.nation_code))])
  }), 1)], 1)], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "placeholder": "请输入手机号码",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.code),
      expression: "form.code"
    }],
    attrs: {
      "placeholder": "请输入短信验证码",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-text",
    class: {
      'gray': _vm.isGetCode || !_vm.form.phone
    },
    domProps: {
      "innerHTML": _vm._s(_vm.timerMsg)
    },
    on: {
      "click": function($event) {
        return _vm.getCode(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "placeholder": "请输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.new_password),
      expression: "form.new_password"
    }],
    attrs: {
      "placeholder": "请再次输入密码",
      "type": "password"
    },
    domProps: {
      "value": (_vm.form.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "new_password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "send-btn margin_34",
    on: {
      "click": function($event) {
        return _vm.register(2)
      }
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "weChat-pay"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.app.weChat),
      expression: "$store.state.app.weChat"
    }],
    staticClass: "weChat-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请使用微信扫码支付")]), _vm._v(" "), _c('div', {
    staticClass: "price-show"
  }, [_vm._v(_vm._s(_vm._f("toFixedPrice")(_vm.$store.state.app.mold.amount)) + "元")]), _vm._v(" "), _c('div', {
    staticClass: "QRcode",
    style: (("background-image: url(" + (_vm.$store.state.app.mold.wechat_url) + ");"))
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.closeTo()
      }
    }
  }, [_vm._v("已完成付款")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.app.alPay),
      expression: "$store.state.app.alPay"
    }],
    staticClass: "alipay-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("请在支付宝页面完成付款")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("付款完成前请不要关闭此弹框")]), _vm._v(" "), (_vm.$store.state.app.goPay) ? _c('a', {
    staticClass: "herf",
    attrs: {
      "href": _vm.$store.state.app.mold.url,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$store.state.app.goPay = false
      }
    }
  }, [_vm._v("点击去支付宝支付")]) : _c('div', {
    staticClass: "btn-boxalert"
  }, [_c('button', {
    staticClass: "btn2 margin_25",
    on: {
      "click": function($event) {
        return _vm.closeTo()
      }
    }
  }, [_vm._v("已完成付款")]), _vm._v(" "), _c('button', {
    staticClass: "btn2",
    on: {
      "click": function($event) {
        return _vm.closeTo(1)
      }
    }
  }, [_vm._v("支付失败")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.app.msg),
      expression: "$store.state.app.msg"
    }],
    staticClass: "alert-message"
  }, [_c('div', {
    staticClass: "msg-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/gantan.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg-alerttext"
  }, [_vm._v("您已点赞该节目,谢谢")])])]), _vm._v(" "), _c('div', {
    staticClass: "registration"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.$store.state.app.registration,
      "size": "tiny",
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.$store.state.app, "registration", $event)
      }
    }
  }, [_c('div', {
    staticClass: "registration-text"
  }, [_c('iframe', {
    attrs: {
      "src": "https://times.yourhr.com.cn/protocol/register_protocol.html",
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-c1709660!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Loginr.vue
// module id = 950
// module chunks = 42